import * as React from "react";
import { Select, Icon } from "antd";

export const Options = (
  items: {
    key: string;
    label: string;
  }[]
) => {
  return items?.map((element) => {
    return <Select.Option key={element.key}>{element.label}</Select.Option>;
  }) || [];
};

export const NotFoundContent = (
  isSearching: boolean,
  fontSize: number = 40
) => {
  return isSearching ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon type="loading" style={{ fontSize }} spin />
    </div>
  ) : (
    "Not Found"
  );
};

// export const DropDown = (isSearching: boolean) => (
//   menu: React.ReactElement
// ) => {
//   return (
//     <div style={{ border: "1px solid rgba(0, 0, 0, 0.15)" }}>
//       {isSearching ? menu : <React.Fragment>{menu}</React.Fragment>}
//     </div>
//   );
// };

export const DropDown = (
  actions?: {
    onClick: (...args) => void;
    label: React.ReactNode;
  }[]
) => (menu: React.ReactNode) => {
  return (
    <React.Fragment>
      {menu}
      {actions?.map(({ onClick, label }) => {
        return <div
          style={{
            color: "#1890FF",
            padding: "4px 12px 6px 12px",
            cursor: "pointer",
            fontSize: "12px",
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={onClick}
        >
          {label}
        </div>;
      })}
    </React.Fragment>
  );
};
